import { render, staticRenderFns } from "./UploadZones.vue?vue&type=template&id=232eb02a&"
import script from "./UploadZones.vue?vue&type=script&lang=js&"
export * from "./UploadZones.vue?vue&type=script&lang=js&"
import style0 from "./UploadZones.vue?vue&type=style&index=0&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports